/* ============================================================================
   Bundled legal docs, loaded as raw markdown via Vite's ?raw import.
   ----------------------------------------------------------------------------
   We bundle these into the app so trainers can read the full legal pack
   without needing a network connection. The same files in /legal on the
   web portal serve as the canonical online versions.
   ============================================================================ */
import tosRaw from "./legal/tos.md?raw";
import privacyRaw from "./legal/privacy.md?raw";

export const TOS_TEXT = tosRaw;
export const PRIVACY_TEXT = privacyRaw;
